import { makeStyles } from "@material-ui/styles";

export default makeStyles(theme => ({
  pageTitleContainer: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: theme.spacing(4),
    marginTop: theme.spacing(4),
  },
  typo: {
    color: theme.palette.text.header,
  },
  button: {
    boxShadow: 'none',
    textTransform: "none",
    "&:active": {
      boxShadow: 'none',
    },
  },
}));
